import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';

const selectAI = (state: RootState) => state.ai;
const selectIsAIAutoMode = createSelector(selectAI, (ai) => ai.isAIAutoMode);
const selectIsAIEscalation = createSelector(
  selectAI,
  (ai) => ai.isAIEscalation
);
const selectAIStatus = createSelector(selectAI, (ai) => ai.aiStatus);

const selectAIEscalationReason = createSelector(
  selectAI,
  (ai) => ai.aiEscalationReason
);
const selectIsAIEscalatedOnCarEnter = createSelector(
  selectAI,
  (ai) => ai.isAIEscalatedOnCarEnter
);
const selectRequiresTakeover = createSelector(
  selectAI,
  (ai) => ai.requiresTakeover
);

// HITL 3.0 (ai_session_state) — Pulse card fields.
const selectAITurn = createSelector(selectAI, (ai) => ai.turn);
const selectAISentimentLabel = createSelector(
  selectAI,
  (ai) => ai.sentimentLabel
);
const selectAIReusedAnswers = createSelector(
  selectAI,
  (ai) => ai.reusedAnswers
);
const selectAIExpressModeActive = createSelector(
  selectAI,
  (ai) => ai.expressModeActive
);

export {
  selectAIStatus,
  selectIsAIAutoMode,
  selectIsAIEscalation,
  selectAIEscalationReason,
  selectIsAIEscalatedOnCarEnter,
  selectRequiresTakeover,
  selectAITurn,
  selectAISentimentLabel,
  selectAIReusedAnswers,
  selectAIExpressModeActive,
};
